
























































































































































































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {ResponsavelGrupoEconomico} from '@/model/resource/ResponsavelGrupoEconomico'
import {InputResponsavelGrupoEconomicoSchema} from '@/schema/resource/ResponsavelGrupoEconomico/InputResponsavelGrupoEconomicoSchema'
import {Responsavel} from '@/model/resource/Responsavel'
import {ResponsavelGrupoEconomicoFilterCollection} from '@/model/filter/ResponsavelGrupoEconomicoFilterCollection'
const sha1 = require('sha1')

@Component
export default class PersistResponsavelGrupoEconomicoView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputResponsavelGrupoEconomicoSchema()
  responsavelGrupoEconomico = new ResponsavelGrupoEconomico()
  responsaveis = new ResponsavelGrupoEconomicoFilterCollection()
  responsavel = new Responsavel()
  confirmSenhaGrupoEconomico = ''
  senhaGrupoEconomico = ''
  senhaResponsavelPermitido = ''

  addNew = false

  async created() {
    await this.populateResource()
    await this.populate()
    await this.applyFilterCollection()
  }

  toggleAddNew() {
    this.addNew = !this.addNew
  }

  async applyFilterCollection() {
    this.responsaveis.id = this.id ?? null
    await $.await.run('listIdsGrupoEconomico', () =>
      this.responsaveis.listIdsGrupoEconomico()
    )
  }

  async removeResponsavel(resp: ResponsavelGrupoEconomico) {
    const idMaster = resp.idResponsavelMasterFk
    const idPermitido = resp.idResponsavelPermitidoFk

    if (idMaster && idPermitido) {
      await this.responsaveis.removeResponsavelGrupoEconomico(
        idMaster,
        idPermitido
      )
      this.$snotify.success(this.$t('system.success.persist') as string)
      await this.applyFilterCollection()
      this.$forceUpdate()
    }
  }

  async populateResource() {
    const id = Number(this.id) || null

    if (id) {
      await this.responsavel.getResponsavel(id)
    }

    $.await.done('getResponsavel')
    this.responsavelGrupoEconomico.reset()
  }
  @Watch('responsavelGrupoEconomico.responsavelPermitido')
  async populate() {
    const idResponsavelPermitido = this.responsavelGrupoEconomico
      ?.responsavelPermitido?.$id

    if (idResponsavelPermitido) {
      const resp = this.responsavelGrupoEconomico.responsavelPermitido?.getResponsavel(
        idResponsavelPermitido
      )

      if (!resp) {
        this.responsavelGrupoEconomico.reset()
      } else {
        this.responsavelGrupoEconomico.idResponsavelPermitidoFk = idResponsavelPermitido
        this.responsavelGrupoEconomico.idResponsavelMasterFk = this.responsavel.idResponsavelPk
      }
    } else {
      this.responsavelGrupoEconomico.reset()
    }
  }

  async persistSenhaMasterGrupoEconomico() {
    if (this.senhaGrupoEconomico !== this.confirmSenhaGrupoEconomico) {
      Helper.abort(
        'view.inputResponsavelGrupoEconomico.error.passwordNotConfirmed'
      )
    }

    if (
      this.senhaGrupoEconomico.length > 0 &&
      this.senhaGrupoEconomico.length < 6
    ) {
      Helper.abort('view.inputResponsavelGrupoEconomico.error.invalidPassword')
    }

    if (this.senhaGrupoEconomico.length == 0) {
      Helper.abort('view.inputResponsavelGrupoEconomico.error.emptyPassword')
    }

    this.responsavel.senhaGrupoEconomico =
      this.senhaGrupoEconomico && this.senhaGrupoEconomico.length
        ? sha1(this.senhaGrupoEconomico)
        : null

    await this.responsavelGrupoEconomico.persistSenhaMasterGrupoEconomico(
      this.responsavel.idResponsavelPk,
      this.responsavel.senhaGrupoEconomico
        ? this.responsavel.senhaGrupoEconomico
        : ''
    )

    this.senhaGrupoEconomico = ''
    this.confirmSenhaGrupoEconomico = ''
    this.$snotify.success(this.$t('system.success.persist') as string)
  }

  async persistVisaoGrupoEconomico() {
    if (
      !this.responsavel.visualizacaoTransportador &&
      !this.responsavel.visualizacaoEmbarcador
    ) {
      Helper.abort('view.inputResponsavelGrupoEconomico.error.hasNoGroup')
    }

    this.responsavelGrupoEconomico.visualizacaoEmbarcador = this.responsavel.visualizacaoEmbarcador
    this.responsavelGrupoEconomico.visualizacaoTransportador = this.responsavel.visualizacaoTransportador
    await this.responsavelGrupoEconomico.persistVisaoGrupoEconomico(
      this.responsavel.idResponsavelPk,
      this.responsavelGrupoEconomico
    )

    this.$snotify.success(this.$t('system.success.persist') as string)
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    if (this.responsavelGrupoEconomico) {
      this.responsavelGrupoEconomico.senha = sha1(
        this.senhaResponsavelPermitido
      )
    }

    await this.responsavelGrupoEconomico.persistResponsavelGrupoEconomico()
    this.$snotify.success(this.$t('system.success.persist') as string)
    $.await.done('getResponsavel')
    this.responsavelGrupoEconomico.reset()
    this.senhaResponsavelPermitido = ''
    this.addNew = false
    await this.applyFilterCollection()
    await this.schema.collectionResponsavel.setSearch(null)
    this.$forceUpdate()
  }
}
